export default function buildMakeFireFlowReport({ makeFlowHydrantReport, makePSIGPMReport }) {
  return function makeFireFlowReport({
    companyId,
    companyName,
    companyAddress,
    companyCity,
    companyState,
    companyZip,
    testDate,
    nfpaClassificationColor,
    nfpaClassificationRating,
    nfpaClassificationValue,
    testHydrant,
    fireFlowTestHydrantId,
    address,
    crossStreet,
    location,
    district,
    subDivision,
    latitude,
    longitude,
    elevation,
    stateX,
    stateY,
    pumpers,
    nozzles,
    openDirection,
    manufacturer,
    model,
    installedDate,
    mainSize,
    vandalProof,
    buryDepth,
    nozzlePSI,
    staticPSI,
    residualPSI,
    percentDrop,
    totalGallonsUsed,
    maxGPM,
    elapsedSeconds,
    predictedGPMAt20PSI,
    flowHydrants,
    psiGPMs
  }) {
    return Object.freeze({
      get companyId() { return companyId },
      get companyName() { return companyName },
      get companyAddress() { return companyAddress },
      get companyCity() { return companyCity },
      get companyState() { return companyState },
      get companyZip() { return companyZip },
      get testDate() { return testDate ? new Date(testDate) : null  },
      get nfpaClassificationColor() { return nfpaClassificationColor },
      get nfpaClassificationRating() { return nfpaClassificationRating },
      get nfpaClassificationValue() { return nfpaClassificationValue },
      get testHydrant() { return testHydrant },
      get fireFlowTestHydrantId() { return fireFlowTestHydrantId },
      get address() { return address },
      get crossStreet() { return crossStreet },
      get location() { return location },
      get district() { return district },
      get subDivision() { return subDivision },
      get latitude() { return latitude },
      get longitude() { return longitude },
      get elevation() { return elevation },
      get stateX() { return stateX },
      get stateY() { return stateY },
      get pumpers() { return pumpers },
      get nozzles() { return nozzles },
      get openDirection() { return openDirection },
      get manufacturer() { return manufacturer },
      get model() { return model },
      get installedDate() { return installedDate },
      get mainSize() { return mainSize },
      get vandalProof() { return vandalProof },
      get buryDepth() { return buryDepth },
      get nozzlePSI() { return nozzlePSI },
      get staticPSI() { return staticPSI },
      get residualPSI() { return residualPSI },
      get percentDrop() { return percentDrop },
      get totalGallonsUsed() { return totalGallonsUsed },
      get maxGPM() { return maxGPM },
      get elapsedSeconds() { return elapsedSeconds },
      get predictedGPMAt20PSI() { return predictedGPMAt20PSI },
      get flowHydrants() { return flowHydrants ? flowHydrants.map(t => makeFlowHydrantReport(t)) : [] },
      get psiGPMs() { return psiGPMs ? psiGPMs.map(p => makePSIGPMReport(p)) : [] },
    });
  }
}